/**
 * Function to get product categories from the products data.
 * @param {Array} products - The array of product objects.
 * @returns {Array} - An array of categories with their count, image, and index.
 */

export const getProductCategories = (products) => {
  const categoryCount = {}; // Object to store the count of each category
  const categoryImage = {}; // Object to store an image for each category

  // Count occurrences of each category and store an image
  products.forEach((product) => {
    // Handle category array (since category is an array in your data)
    product.category.forEach((category) => {
      categoryCount[category] = (categoryCount[category] || 0) + 1; // Increment count for the category
      if (!categoryImage[category]) categoryImage[category] = product.image; // Store first product's image
    });
  });

  // Convert to an array, sort by count (descending)
  return Object.entries(categoryCount)
    .sort((a, b) => b[1] - a[1])
    .map(([category, count], index) => ({
      index: index + 1, // Add index (1-based)
      category,
      count,
      image: categoryImage[category],
    }));
};